import $ from "jquery";
import salvattore from "salvattore";
import _ from "../vendor/lodash/lodash.custom.min.js";

// HTML5 history API (prevents chrome from listing to the first event on page load)
var everPushedSomething = false;
// get inital viewport width
var viewportWidth = window.innerWidth;


// ES6 endsWith Polyfill (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith)
if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (searchString, position) {
        var subjectString = this.toString();
        if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
            position = subjectString.length;
        }
        position -= searchString.length;
        var lastIndex = subjectString.lastIndexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    };
}


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *	on jQuery ready
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
$(function () {
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *	init Foundation Components
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

    //$(document).foundation();

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     *	init Custom Components
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     *	mobile navigation toggle / hamburger
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

    var $nav = $('.pagenav nav'),
        $menuButton = $('.open-nav'),
        $triggerWord = $('.trigger-status');

    $menuButton.on('click', function () {
        $(this).toggleClass('active');
        $nav.toggleClass('active');

        if ($nav.hasClass('active') === true) {
            $(this).attr('aria-expanded', 'true');
            $triggerWord.text('schließen');
        } else {
            $(this).attr('aria-expanded', 'false');
            $triggerWord.text('öffnen');
        }
    });


    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     *	HTML5 History event
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

    $(window).on('resize', _.debounce(function () {
        if (viewportWidth != window.innerWidth) {
            // width changed, so let's update salvattore columns
            if ($('.pagecontent [data-columns]').length) salvattore.recreateColumns($('.pagecontent [data-columns]')[0]);
            // set new width
            viewportWidth = window.innerWidth;
        }
    }, 300));



    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     *	scroll to id from url hash
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

    if (window.location.hash !== '' && window.location.hash.charAt(1) != '&' && $(window.location.hash).length > 0) {
        setTimeout(function () {
            $('html, body').animate({ scrollTop: $(window.location.hash).offset().top - 50 }, 1000);
        }, 500);
    }


    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     *	process link tags
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

    $('body').on('click', 'a', function (e) {
        var href = $(this).attr('href');

        if ($(this).attr('target') === '_blank' || href.endsWith('.pdf') || href.endsWith('.png') || href.endsWith('.jpg') || href.endsWith('.doc') || href.endsWith('.docx')) {
            return true;
        }

        // scroll to id if hash link clicked
        if (href.charAt(0) == '#' && href.length > 1 && $(href).length && typeof $(this).attr('aria-expanded') !== 'undefined') {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: ($(href).offset().top - 13)
            }, 1000);
            return false;
        }

        if (window.innerWidth > 1023 && href.indexOf('mailto:') === -1 && (href.indexOf('http') === -1 || (href + '/').indexOf('freshpepper.de/') !== -1) && href.length > 1) {
            // ajax navigation
            navigateTo(href);
            return false;
        }

        return true;
    });



	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *	HTML5 History event
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

    $(window).on('popstate', function () {
        if (everPushedSomething) {
            var link = location.pathname.replace(/^.*[\\/]/, ""); // get filename only
            navigateTo(link);
        }
        everPushedSomething = true;
    });


    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     *	Load more cards
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

    $('body').on('click', '#loadCardsButton', function () {
        const $button = $(this);
        var offset = parseInt($button.data('offset'));
        var limit = parseInt($button.data('limit'));
        if (offset === 0) offset = 6;
        if (limit === 0) limit = 3;
        $button.addClass('active');
        $.ajax({
            url: '/ajaxnews?&limit=' + limit + '&offset=' + offset,
            success: function (response) {
                $('.pagecontent [data-columns]').addClass('no-animation-delay');
                if (response !== '') {
                    var $grid = $('.pagecontent [data-columns]');
                    var $items = $(response);
                    salvattore.appendElements($grid[0], $items.toArray());
                } else {
                    $button.addClass('disabled').text($button.data('endtext')).attr('disabled', 'disabled');
                }
            },
            error: function (e) {
                if (window.console) console.error('error getting more cards', e);
            }
        }).done(function () {
            $button.data('offset', offset + limit);
            $button.removeClass('active');
        });
    });

});

function navigateTo(href) {
    //if (window.console) console.log('navigating to '+href);
    $('html, body').animate({ scrollTop: 0 }, 500);
    if (supports_history_api()) {
        $('html').addClass('navigation-in-progress');
        try {
            $('.pagecontent').load(href + ' .pagecontent > *', function () {
                if ($('.pagecontent [data-columns]').length) {
                    salvattore.registerGrid($('.pagecontent [data-columns]')[0])
                };

                history.pushState(null, null, href);
                $('html').removeClass('navigation-in-progress');
                everPushedSomething = true;
            });

            $.ajax({
                url: href,
                success: function (response) {
                    $('.pagecontent *').remove();
                    $('.pagecontent').append($(response).find('.pagecontent > *'));
                    if ($('.pagecontent [data-columns]').length) salvattore.registerGrid($('.pagecontent [data-columns]')[0]);
                    $('html').removeClass('navigation-in-progress');

                    // Set New Title
                    document.title = $(response).filter('title').text();

                    history.pushState(null, document.title, href);
                    everPushedSomething = true;
                }
            });

        } catch (e) {
            if (window.console) console.error('Content load error', e);
            // Load error fallback
            window.location = href;
        }

        // update navigation active class
        $('.pagenav *').removeClass('active');
        $('.pagenav a[href="' + href + '"]').parent().addClass('active');
        if (typeof ga === 'function') ga('send', 'pageview', href);

    } else {
        // Fallback for no history support
        window.location = href;
    }

}

function supports_history_api() {
    return !!(window.history && history.pushState);
}
